const firebaseConfig = {
    apiKey: "AIzaSyBJgG6JOT4-CqNRZiP5HZOR87Dwi3ms1oM",
    authDomain: "medilab-dca8a.firebaseapp.com",
    projectId: "medilab-dca8a",
    storageBucket: "medilab-dca8a.appspot.com",
    messagingSenderId: "190772614032",
    appId: "1:190772614032:web:6db03b1752da6739dd5915",
    measurementId: "G-1D1FKGSQQE"
  };

export default firebaseConfig;